// extracted by mini-css-extract-plugin
module.exports = {"root":"Image__root___5wqh5","imageContainer":"Image__imageContainer___3rzF0","loadingPlaceholderContainer":"Image__loadingPlaceholderContainer___ossRy"};